import { TabBookingAbstract } from './tabBookingAbstract'
import { cache, cacheName } from '@/utils/cacheManager'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { ClearingUtils } from '@/class/cargo/model/utils/ClearingUtils'
import {
  queryTabBilling,
  queryTabBillingByBranchId,
  deleteBilling,
  recheckBilling,
  cancelRecheckBilling,
  batchConfirmBilling,
  batchUnConfirmBilling,
  batchDelBilling,
  forceDeleteBilling, validateForceDeleteBilling, getOverseaBillSameGroup
} from '@/api/clearing/billingNative'
import { getChargeByBillUuid } from '@/api/clearing/charge'
import StrUtils from '@/utils/StrUtils'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { Company } from '@/class/model/mdm/Company'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import { sortByMultiField } from '@/utils'
import {
  autidBilling,
  invalidBilling,
  loadAgentRelationCharge
} from '@/api/clearing/billingNative'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import { Billing } from '@/class/model/act/Billing'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as NumberUtils from '@/utils/NumberUtils'
import { getChargeList } from '@/api/seaExport/seaExportJob'
import { getAgentSharedCharge } from '@/api/clearing/charge'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { User } from '@/class/model/sys/User'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
export const INTERNALBILLING = 'INTERNALBILLING'
export const BILLING = 'BILLING'
export const SHOW_BILLING_CACHE_KEY = 'oversea-billing-show-all'
export const SHOW_SELF_CACHE_KEY = 'oversea-show-self-charge'
import * as BillingRateUtil from '@/class/cargo/model/utils/BillingRateUtil'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import moment from 'moment'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as BillingUtils from '@/class/cargo/model/utils/BillingUtils'

export class OverseaBillingBase extends TabBookingAbstract {
  /**
   * @param {Object} view 视图
   */
  constructor(view) {
    super(view)
    this.$message = this.view.$message
    this.$alert = this.view.$alert
    this.$confirm = this.view.$confirm
    this.$refs = this.view.$refs
    this.$store = this.view.$store
    this.$i18n = this.view.$i18n
    this.$emit = this.view.$emit
    this.$t = this.view.$t
    this.$checkPermission = this.view.$checkPermission
    this.isVerify = false // 是否财务审核
    this._isAr = false //  收支类型
    this._selectedAcountId = 0 // 结算对象
    this.billCharges = []// 费用
    this.userChargeRole = this.$checkPermission(['role_Charge_userCharge']) // 本人费用
    this.branchChargeRole = this.$checkPermission(['role_Charge_branchCharge']) // 所有费用
    this.departmentChargeRole = this.$checkPermission(['role_Charge_departmentCharge']) // 本人及同组费用
    this.departmentTeamUser = null // 同部门的人
    this.sameGroupInfo = null // 同组信息

    this.isControlled = this.$checkPermission(['button_Charge_controlled'])// 是否有应付受控费用权限

    /**
     * 是否有应收受控费用权限
     */
    this.isCostControlled = this.$checkPermission(['button_Charge_costControlled'])

    this.invoiceSyncRate = 0 // 汇率同步参数
    this.isRevoke = false // 强制删除
    /**
     * 是否启用佣金(淳宏)
     */

    this.enableCommission = false

    this.isBulkPrint = true

    /**
     * 当前账单所属分公司
     */

    this.currentBillingBranchId = 0

    /**
     * 编辑同组
     */

    this.editByDep = false
    /**
     * 编辑所有
     */

    this.editByAll = false

    /**
     * 删除同组
     */

    this.deleteByDep = false
    this.deleteBySelf = false // 删除个人
    this.deleteByAll = false // 删除所有
    this.billVerifyByDep = false // 审核同组
    this.billVerifyByAll = false // 审核所有
    this.overseaBillingInvalidByDep = false // 作废同组
    this.overseaBillingInvalidByAll = false // 作废所有
    this.overseaBillingEditAgentBillNoByDep = false // 编辑代理账单号同组
    this.overseaBillingEditAgentBillNoByAll = false // 编辑代理账单号所有
    this._billingCharges = []
    this._billingChargeAccountcodes = []

    /**
     * 操作通常允许文件上传与删除，销售只允许查看，不能编辑
     */
    this.isAllowedEdit = true

    this.isAddBillTaxAmount = false
    this.debitChargetaxRate = 0
    this._billingChargeAccountcodes = []
    this.isSaveBillRate = 0
    this.billingAndBillingGroupPrivilegeMode = false
  }

  get context() {
    return this.view.context
  }

  set context(context) {
    this.view.context = context
  }

  get user() {
    return this.view.context.user
  }

  set user(user) {
    this.view.context.user = user
  }

  get job() {
    return this.view.job
  }

  set job(job) {
    this.view.job = job
  }

  get selectedBilling() {
    return this.view.selectedBilling
  }

  set selectedBilling(selectedBilling) {
    this.view.selectedBilling = selectedBilling
  }

  get billingList() {
    return this.view.billingList
  }

  set billingList(billingList) {
    this.view.billingList = billingList
  }

  /**
   * 显示特殊费用
   */
  get showSpecialCharge() {
    return this.view.controllerVisible.showSpecialCharge
  }

  set showSpecialCharge(showSpecialCharge) {
    this.view.controllerVisible.showSpecialCharge = showSpecialCharge
  }

  /**
   * 默认账单所属分公司
   */
  get specialBillingBranchId() {
    return this.view.specialBillingBranchId
  }

  set specialBillingBranchId(specialBillingBranchId) {
    this.view.specialBillingBranchId = specialBillingBranchId
  }
  /**
   * 是否付款锁定
   */
  get isOcPaymentLock() {
    if (this.selectedBilling && this.selectedBilling.ocPaymentLock !== undefined) return this.selectedBilling.ocPaymentLock
    return false
  }
  async commitProperties() {
    this.buttonStateControl()
    this.view.controllerVisible.cbShowSelfChanges = !this.job.masterFlag
    this.view.controllerVisible.btnPrintAllAgent = this.job.masterFlag && (this.job.lob === 'SE') && this.job.containerLoadType !== ContainerLoadType.FCL_CARGO_TYPE.code
    this.view.controllerVisible.cbShowInternal = RateUtil.useOrderCenterMode()
    await this.loadBilling()
    // 初始化同组
    await this.initializeUserDepartmentTeam()
  }

  async initializeHandler() {
    // CARGO-2262，业务详情-账单
    await cache.load(cacheName.USER, cacheName.CONFIG)
    this.enableCommission = parseInt(cache.config.get('enableCommission')) === 1
    this.isBulkPrint = parseInt(cache.config.get('IsBulkPrint')) !== 1 // 注意，这里==1是false, 反之是true
    this.view.createOverseaCharge = Number(cache.config.get('CreateInvoiceByOverseaCharge')) === 1
    this.showSpecialCharge = this.$checkPermission(['button_Charge_showSpecialCharge'])
    this.editByDep = this.$checkPermission(['button_billTab_editByDep'])
    this.editByAll = this.$checkPermission(['button_billTab_edit'])
    this.deleteByDep = this.$checkPermission(['button_billTab_deleteByDep'])
    this.deleteBySelf = this.$checkPermission(['button_billTab_deleteSelf'])
    this.deleteByAll = this.$checkPermission(['button_billTab_delete'])
    this.billVerifyByDep = this.$checkPermission(['button_SEBooking_billVerifyByDep'])
    this.billVerifyByAll = this.$checkPermission(['button_SEBooking_billVerify'])
    this.overseaBillingInvalidByDep = this.$checkPermission(['button_billTab_overseaBillingInvalidByDep'])
    this.overseaBillingInvalidByAll = this.$checkPermission(['button_billTab_overseaBillingInvalid'])
    this.overseaBillingEditAgentBillNoByDep = this.$checkPermission(['button_billTab_overseaBillingEditAgentBillNoByDep'])
    this.overseaBillingEditAgentBillNoByAll = this.$checkPermission(['button_billTab_overseaBillingEditAgentBillNo'])
    if (this.enableCommission) {
      if (this.showSpecialCharge) {
        // 账单所属分公司
        if (LocalStorageUtils.getConfiguration('specialBillingBranchId')) {
          this.specialBillingBranchId = parseInt(LocalStorageUtils.getConfiguration('specialBillingBranchId'))
        } else {
          this.specialBillingBranchId = this.view.$store.getters.currentOfficeId
        }
        this.currentBillingBranchId = this.specialBillingBranchId
      }
    }
    this.view.cbShowAllBilling = false
    if (LocalStorageUtils.getConfiguration(SHOW_BILLING_CACHE_KEY)) {
      this.view.cbShowAllBilling = true
    }

    this.view.cbShowSelfChanges = false
    if (LocalStorageUtils.getConfiguration(SHOW_SELF_CACHE_KEY)) {
      this.view.cbShowSelfChanges = true
    }
    this.view.cbShowInternal = true

    // 初始化 config参数
    this.loadConfigValuesHandler()
  }

  loadConfigValuesHandler() {
    this.isAddBillTaxAmount = String(cache.config.get('billTaxAmount')) === '1'
    this.debitChargetaxRate = parseInt(cache.config.get('debitChargetaxRate'))
    this.isSaveBillRate = parseInt(cache.config.get('isSaveBillRate'))
    this.billingAndBillingGroupPrivilegeMode = Number(cache.config.get('BillingAndBillingGroupPrivilegeMode')) === 1
  }
  /**
   * 按钮状态控制
   */
  buttonStateControl() {
    if (!this.job) { return }
    const selectedRows = this.view.up.gridApi ? this.view.up.gridApi.getSelectedRows() : []
    const billing = this.selectedBilling
    const isEditing = this.view.isEdit
    const job = this.job
    this.view.btnEnable.btnAdd = !isEditing
    this.view.btnEnable.ddlBranchId = !isEditing
    this.view.btnEnable.btnEdit = this.editable(billing)
    this.view.btnEnable.btnConfirm = (job && billing && !billing.confirmed && !isEditing && !billing.billingGroupUuid && billing.billingNo && billing.billingType === BillingConstants.BILLING_TYPE_OVERSEA.code)
    this.view.btnEnable.btnCancelConfirm = (job && billing && billing.confirmed && !isEditing && !billing.billingGroupUuid && billing.billingNo && billing.billingType === BillingConstants.BILLING_TYPE_OVERSEA.code) && billing && billing.review === 0

    // Jira:778 代理分成账单产生的费用一旦本做到国外账单中、被审核、被核销、被确认、本分拆，则代理分成账单不允许进行编辑，防止数据不一致。
    if (billing && billing.billingType === BillingConstants.BILLING_TYPE_AGENT.code) {
      if (billing.agentSharedCharge && billing.agentSharedCharge.length > 0) {
        const charge = billing.agentSharedCharge[0]
        // 做了付款申请的不允许编辑 已在上面的 if 中增加了 billingPaymentUuid 的判断
        if (charge && (charge.billingUuid || charge.billingAmount || charge.invoiceUuid || charge.verifiedAmount !== 0 || charge.billingPaymentUuid || charge.chargeState > 0)) {
          this.view.btnEnable.btnEdit = false
        }
      }
    }

    this.view.permission.btnDel = (this.$checkPermission(['button_billTab_delete']) || this.deleteByDep || this.deleteBySelf) && billing && billing.review === 0
    this.view.btnEnable.btnDel = this.view.btnEnable.btnEdit

    // CARGO-7873 若国外账单是已作废状态，则“删除”按钮可点击
    if (billing && (billing.state === BillingConstants.BILLING_INVALID.code || billing.revoked)) {
      this.view.btnEnable.btnDel = true
    }
    this.view.btnEnable.btnDel = this.view.btnEnable.btnDel && !this.isOcPaymentLock

    this.view.permission.btnAutid = this.isAllowedEdit
    this.view.btnEnable.btnAutid = (this.view.readonly && billing && billing.ar === false && (billing.state === 0 || billing.state === -1) && !billing.billingGroupUuid)

    this.view.permission.btnInvalid = this.isAllowedEdit && this.$checkPermission(['button_billTab_overseaBillingInvalid']) && selectedRows.length > 0
    this.view.btnEnable.btnInvalid = this.view.readonly

    this.view.btnEnable.btnAgent = this.view.readonly && job.jobState === 0

    this.view.permission.btnEditAgentBillNo = this.view.$store.getters.isAdmin || this.$checkPermission(['button_billTab_overseaBillingEditAgentBillNo'])
    this.view.btnEnable.btnEditAgentBillNo = !((billing == null || StrUtils.isEmpty(billing.billingNo) || billing.state === BillingConstants.BILLING_INVALID.code || billing.revoked))

    let billings = []
    if (selectedRows && selectedRows.length !== 0) {
      billings = [...selectedRows]
    } else if (billing) {
      billings.push(billing)
    }
    // 处理【复核】、【取消复核】是否置灰
    if (isEditing) {
      this.view.btnEnable.btnRecheck = false
      this.view.btnEnable.btnCancelRecheck = false
    } else {
      if (billings.length === 0) {
        this.view.btnEnable.btnRecheck = false
        this.view.btnEnable.btnCancelRecheck = false
      } else {
        this.view.btnEnable.btnRecheck = true
        this.view.btnEnable.btnCancelRecheck = true
        for (const item of billings) {
          // 确认状态为【已确认】且复核状态为【未复核】时，【复核】按钮可点击
          if (!(item.confirmed && item.review === 0)) {
            this.view.btnEnable.btnRecheck = false
          }
          if (item.review === 0) {
            this.view.btnEnable.btnCancelRecheck = false
          }
        }
      }
    }
    //
    this.buttonStateControlByDep()
  }
  editable(billing) {
    return (this.view.readonly && billing && !billing.billingGroupUuid && ((billing.state === -1 && !billing.confirmed) || billing.state === 0 || (billing.state === 2 && !billing.confirmed)) && billing.invoiceState === 0 && billing.realClearingState === ClearingConstants.CLEARING_STATE_NON.code) && !this.isOcPaymentLock && billing.review === 0
  }

  /**
   * 按钮状态控制：同组
   */
  buttonStateControlByDep() {
    if (!this.enableCommission || !this.sameGroupInfo) return
    const selectedRows = this.view.up.gridApi ? this.view.up.gridApi.getSelectedRows() : []
    const billing = this.selectedBilling
    if (billing) {
      // 是否创建人同组
      let sameDep = false
      if (this.billVerifyByDep) {
        sameDep = this.checkBillingDepartmentTeam(billing)
      }
      let depSameGroup = {}
      if (this.editByDep || this.deleteByDep || this.overseaBillingEditAgentBillNoByDep) {
        depSameGroup = this.checkBillingSameGroup(billing)
      }

      // 编辑
      if (this.editByAll) { // 所有：按原有逻辑
        this.view.btnEnable.btnEdit = this.editable(billing)
      } else if (this.editByDep) {
        this.view.btnEnable.btnEdit = depSameGroup.editByDep && this.editable(billing)
      } else {
        this.view.btnEnable.btnEdit = false
      }
      // Jira:778 代理分成账单产生的费用一旦本做到国外账单中、被审核、被核销、被确认、本分拆，则代理分成账单不允许进行编辑，防止数据不一致。
      if (this.view.btnEnable.btnEdit && billing && billing.billingType === BillingConstants.BILLING_TYPE_AGENT.code) {
        if (billing.agentSharedCharge && billing.agentSharedCharge.length > 0) {
          const charge = billing.agentSharedCharge[0]
          // 做了付款申请的不允许编辑 已在上面的 if 中增加了 billingPaymentUuid 的判断
          if (charge && (charge.billingUuid || charge.billingAmount || charge.invoiceUuid || charge.verifiedAmount !== 0 || charge.billingPaymentUuid || charge.chargeState > 0)) {
            this.view.btnEnable.btnEdit = false
          }
        }
      }
      this.view.btnEnable.btnEdit = this.view.btnEnable.btnEdit && !this.isOcPaymentLock

      // 删除
      if (this.deleteByAll) {
        this.view.btnEnable.btnDel = this.editable(billing)
      } else if (this.deleteByDep) {
        this.view.btnEnable.btnDel = depSameGroup.deleteByDep && this.editable(billing)
      } else if (this.deleteBySelf) {
        this.view.btnEnable.btnDel = this.editable(billing)
      } else {
        this.view.btnEnable.btnDel = false
      }
      // CARGO-7873 若国外账单是已作废状态，则“删除”按钮可点击
      if ((!this.view.btnDel && (this.deleteByAll || this.deleteByDep)) && billing && (billing.state === BillingConstants.BILLING_INVALID.code || billing.revoked) && billing.review === 0) {
        this.view.btnEnable.btnDel = true
      }
      this.view.btnEnable.btnDel = this.view.btnEnable.btnDel && !this.isOcPaymentLock

      // 审核
      if (this.billVerifyByAll) {
        this.view.btnEnable.btnAutid = (this.view.readonly && billing && billing.ar === false && (billing.state === 0 || billing.state === -1) && StrUtils.isEmpty(billing.billingGroupUuid))
      } else if (this.billVerifyByDep) {
        this.view.btnEnable.btnAutid = sameDep && (this.view.readonly && billing && billing.ar === false && (billing.state === 0 || billing.state === -1) && StrUtils.isEmpty(billing.billingGroupUuid))
      } else {
        this.view.btnEnable.btnAutid = false
      }

      // 作废
      if (!this.view.permission.btnInvalid) {
        if (this.overseaBillingInvalidByAll) {
          this.view.permission.btnInvalid = this.view.readonly && selectedRows.length > 0
        } else if (this.overseaBillingInvalidByDep) {
          this.view.permission.btnInvalid = this.view.readonly && this.checkBillingsSameGroup(selectedRows, 'overseaBillingInvalidByDep')
        }
      }

      // 编辑代理账单号
      if (this.overseaBillingEditAgentBillNoByAll) {
        this.view.btnEnable.btnEditAgentBillNo = !((billing == null || StrUtils.isEmpty(billing.billingNo) || billing.state === BillingConstants.BILLING_INVALID.code || billing.revoked))
      } else if (this.overseaBillingEditAgentBillNoByDep) {
        this.view.btnEnable.btnEditAgentBillNo = depSameGroup.overseaBillingEditAgentBillNoByDep && (!((billing == null || StrUtils.isEmpty(billing.billingNo) || billing.state === BillingConstants.BILLING_INVALID.code || billing.revoked)))
      } else {
        this.view.btnEnable.btnEditAgentBillNo = false
      }
    }
  }

  /**
   * 账单创建人同组
   */
  checkBillingDepartmentTeam(billing) {
    if (billing.createdBy === this.user.userId) {
      return true
    }

    for (const userId of this.departmentTeamUser) {
      if (userId === billing.createdBy) {
        return true
      }
    }

    return false
  }

  /**
   * 账单创建人同组
   */
  checkBillingSameGroup(billing) {
    const result = {}
    const names = ['overseaBillingInvalidByDep', 'deleteByDep', 'editByDep', 'overseaBillingEditAgentBillNoByDep']
    for (const name of names) {
      if ((billing.createdBy || billing.inputBy) === this.user.userId) {
        result[name] = true
        continue
      }
      for (const userId of this.sameGroupInfo[name]) {
        if (userId === (billing.createdBy || billing.inputBy)) {
          result[name] = true
          break
        }
        if (!this.billingAndBillingGroupPrivilegeMode) {
          if (userId === billing.sales) {
            result[name] = true
            break
          }
        }
      }
    }
    return result
  }

  /**
   * 账单创建人同组（多个）
   */
  checkBillingsSameGroup(billings, name) {
    if (billings.length > 0) {
      for (const billing of billings) {
        const billingResult = this.checkBillingSameGroup(billing)
        if (!billingResult[name]) {
          return false
        }
      }
      return true
    }
    return false
  }

  async loadBilling() {
    const job = this.job
    if (!job || !job.uuid) {
      this.view.billingList = []
      this.view.chargeList = []
    } else {
      this.refreshGrid() // 刷新表格并清除选中
      // 加载数据
      const job = this.getJobByLob()
      await Promise.all([
        job.getLclSlaves(),
        job.getCharges()
      ])
      const jobKeys = [job.uuid]
      const showAllBilling = LocalStorageUtils.getConfiguration(SHOW_BILLING_CACHE_KEY)
      if (showAllBilling != null && showAllBilling && job.masterFlag) {
        for (const slave of job.lclSlaves) {
          jobKeys.push(slave.uuid)
        }
      }

      const params = { jobUuids: jobKeys, billingTypes: [BillingConstants.BILLING_TYPE_OVERSEA.code, BillingConstants.BILLING_TYPE_NORMAL.code, BillingConstants.BILLING_TYPE_AGENT.code] }
      // 非佣金
      if (!this.enableCommission) {
        if (RateUtil.useOrderCenterMode()) params.officeId = this.$store.getters.currentOfficeId
        params.whtTaxModeBranchId = this.$store.getters.currentOfficeId
        // 调用后端api
        await queryTabBilling(params).then(res => {
          this.loadChargeBillingHandler(res.data)
        })
      } else {
        if (this.showSpecialCharge && this.currentBillingBranchId > 0) {
          // 账单所属分公司
          params.officeId = this.currentBillingBranchId
          await queryTabBillingByBranchId(params).then(res => {
            this.loadChargeBillingHandler(res.data)
          })
        } else {
          if (RateUtil.useOrderCenterMode()) params.officeId = this.$store.getters.currentOfficeId
          // 调用后端api
          await queryTabBilling(params).then(res => {
            this.loadChargeBillingHandler(res.data)
          })
        }
      }
    }
  }

  loadChargeBillingHandler(data) {
    this.view.chargeList = []
    this.billingList = []
    const wapper = data
    ClearingUtils.mergeWriteoffableResult(wapper)
    ClearingUtils.mergeInvoiceableResult(wapper)
    ClearingUtils.mergeGroupBillingNos(wapper)
    ClearingUtils.mergePaymentStateResult(wapper)
    const isR = wapper.isR
    for (const billing of wapper.results) {
      const t = isR[billing.uuid]
      if (billing.ar && CargoDocUtil.checkBill(this.isCostControlled, this.isControlled, t)) {
        this.billingList.push(billing)
      }
      if (!billing.ar && CargoDocUtil.checkBill(this.isCostControlled, this.isControlled, t)) {
        this.billingList.push(billing)
      }
    }
    this.buttonStateControl()
    // todo dispatchEvent(new Event("printChanged"));
  }

  /**
   * CARGO-2262，业务详情-账单：开启佣金、有同组权限的，初始化同组
   */
  async initializeUserDepartmentTeam() {
    if (this.enableCommission && (this.editByDep || this.deleteByDep || this.confirmByDep || this.cancelConfrimByDep || this.billVerifyByDep || this.overseaBillingInvalidByDep || this.overseaBillingEditAgentBillNoByDep)) {
      const res = await getOverseaBillSameGroup({ branchId: this.view.$store.getters.currentOfficeId })
      this.sameGroupInfo = res.data
    }
    // 启用佣金、有 编辑、删除、确认、取消确认同组权限的
    if (this.enableCommission && (this.editByDep || this.deleteByDep || this.confirmByDep || this.cancelConfrimByDep || this.billVerifyByDep || this.overseaBillingInvalidByDep || this.overseaBillingEditAgentBillNoByDep) && this.departmentTeamUser == null) {
      const resData = await User.getUserDepartmentTeam()
      this.initializeUserDepartmentTeamHandler(resData)
    }
  }

  initializeUserDepartmentTeamHandler(data) {
    if (data) {
      this.departmentTeamUser = data
      //
      this.buttonStateControlByDep()
    }
  }

  onUpCellFocused(event) {
    if (this.view.up.gridApi && event.column) {
      this.view.up.gridApi.forEachNode(node => {
        if (node.rowIndex === event.rowIndex) {
          this.selectedBilling = node.data
        }
      })
    }
    this.reloadBillingHandler(this.selectedBilling)
  }

  onRowSelected(event) {
    if (!event || !event.data) return
    if (event.node.isSelected()) {
      this.view.selectedDataList.push(event.data)
    } else {
      this.view.selectedDataList = this.view.up.gridApi.getSelectedRows()
    }
    this.onBillingGridItemClick(event)
  }

  /**
   * 显示費用
   * @param event
   */
  onBillingGridItemClick(event = null) {
    this.selectedBilling = null
    this.view.chargeList = []
    if (event) {
      this.selectedBilling = event.data
    }
    if (!this.selectedBilling) {
      const selectList = this.view.up.gridApi.getSelectedRows()
      this.selectedBilling = selectList && selectList.length === 1 ? selectList[0] : this.selectedBilling
    }
    if (this.selectedBilling) {
      this.reloadBillingHandler(this.selectedBilling)
    }
    this.view.up.gridApi.refreshCells({ force: true }) // 刷新
  }

  async reloadBillingHandler(data) {
    const billing = data
    if (billing != null) {
      if (billing.billingType === BillingConstants.BILLING_TYPE_AGENT.code) {
        // 调用后端api
        await loadAgentRelationCharge(billing.uuid).then(async(res) => {
          this.view.chargeList = res.data
          billing.agentCharge = res.data
          await getAgentSharedCharge(billing.uuid).then(res => {
            billing.agentSharedCharge = res.data
          })
        })
      } else {
        // 调用后端api
        await getChargeByBillUuid(billing.uuid).then(res => {
          // 加载费用后赋值给bill 费用List属性上
          this.view.chargeList = res.data
          billing.charge = res.data
          this.loadChargeDataFunc()
        })
      }

      this.buttonStateControl()

      if ((this.$checkPermission(['button_SEBooking_billVerify']) || this.view.$store.getters.isAdmin) && this.view.readonly) {
        if (this.selectedBilling.ar === false && (this.selectedBilling.state === 0 || this.selectedBilling.state === -1)) {
          this.view.btnEnable.btnAutid = true
        } else {
          this.view.btnEnable.btnAutid = false
        }
      } else {
        this.view.btnEnable.btnAutid = false
      }
    }
  }
  loadBillingChargeHandler() {
    this.buttonStateControl()
    this.view.chargeList = []
    const billing = this.selectedBilling
    if (billing) {
      if (billing.billingType === BillingConstants.BILLING_TYPE_AGENT.code) {
        this.view.chargeList = billing.agentCharge
      } else {
        getChargeByBillUuid(billing.uuid).then(res => {
          // 加载费用后赋值给bill 费用List属性上
          this.view.chargeList = res.data
          this.billing.charge = res.data
          this.loadChargeDataFunc()
        })
      }
    }
  }

  loadChargeDataFunc(data = null) {
    const charges = []
    let chargeList = []
    if (data == null) {
      chargeList = this.selectedBilling.charge
    } else {
      chargeList.push(data)
    }
    // 翻译 charges.filterFunction = this.chargefilterFunc()
    for (const charge of chargeList) {
      if (this.chargefilterFunc(charge)) {
        if (RateUtil.useOrderCenterMode()) {
          if (this.view.cbShowInternal || (!this.view.cbShowInternal && !charge.internal)) {
            charges.push(charge)
          }
        } else {
          charges.push(charge)
        }
      }
    }
    if (charges.length === 0) {
      if (RateUtil.useOrderCenterMode()) this.view.chargeList = []
      return
    }
    const sortCharges = sortByMultiField(charges, ['receivable', 'chargeId'], true)
    this.view.chargeList = sortCharges
  }

  /**
   * 过滤费用
   */
  chargefilterFunc(charge) {
    return !this.view.cbShowSelfChanges || (this.view.cbShowSelfChanges && charge.jobUuid === this.job.uuid)
  }

  // 新增
  async onAddClickEvent() {
    // this.loadJobsChargeHandler()
    this._billingCharges = []
    const billTabCharges = await BillingUtils.getBillTabCharges(this.view, this.job, false, true, {
      enableCommission: this.enableCommission,
      showSpecialCharge: this.showSpecialCharge,
      currentBillingBranchId: this.currentBillingBranchId,
      viewSource: this.view.viewSource,
      departmentTeamUser: this.departmentTeamUser
    })
    if (billTabCharges) {
      this._billingCharges = billTabCharges
      this.checkRoleBillingCharge()
    }
  }

  loadJobsChargeHandler(data = null) {
    this.getBillingCharges()
  }
  /**
   * 获取账单费用
   */
  async getBillingCharges() {
    this._billingCharges = []
    await this.loadJobCharge()
  }

  async loadJobCharge() {
    const _job = this.job
    // 获取当前job 上的费用list（重新加载获取）
    const jobCharges = await getChargeList(_job.uuid).then(res => res.data)
    // 是否有应付受控费用权限
    const isControlled = this.$checkPermission(['button_Charge_controlled'])
    // 是否有应收受控费用权限
    const isCostControlled = this.$checkPermission(['button_Charge_costControlled'])
    const curCharges = []
    for (const item of jobCharges) {
      const controlled = item.controlled // 是否受控
      const receivable = item.receivable // 应收应付
      if (controlled) {
        if (receivable && !isCostControlled) {
          continue
        }
        if (!receivable && !isControlled) {
          continue
        }
      }
      curCharges.push(item)
    }
    this.getJobCharges(curCharges)
    if (_job.masterFlag) {
      for (const job of _job.lclSlaves) {
        const lclJobCharges = await getChargeList(job.uuid).then(res => res.data)
        this.getJobCharges(lclJobCharges)
      }
    }
    if (this.view.viewSource && this.view.viewSource === 'salesDetail') {
      this._billingCharges = this.getCreateByRoleBillingCharges()
      this.checkRoleBillingCharge()
    } else {
      if (this.branchChargeRole || this.checkChargeCreatedBy()) {
        this.checkRoleBillingCharge()
      } else if (this.departmentChargeRole) {
        if (this.departmentTeamUser === null) {
          const resData = await User.getUserDepartmentTeam()
          this.getUserDepartmentTeamHandler(resData)
        } else {
          this.getUserDepartmentTeamHandler()
        }
      } else if (this.userChargeRole) {
        this._billingCharges = this.getCreateByRoleBillingCharges()
        this.checkRoleBillingCharge()
      }
    }
  }

  getCreateByRoleBillingCharges() {
    const charges = []
    for (const charge of this._billingCharges) {
      if (charge.createdBy === this.user.userId) {
        if (!this.enableCommission) {
          charges.push(charge)
        } else {
          if (this.showSpecialCharge && this.currentBillingBranchId > 0) {
            if (charge.branchId === this.currentBillingBranchId) {
              charges.push(charge)
            }
          } else {
            if (charge.branchId === this.view.$store.getters.currentOfficeId) {
              charges.push(charge)
            }
          }
        }
      }
    }
    return charges
  }

  checkRoleBillingCharge() {
    if (this._billingCharges.length === 0) {
      this.$message.warning(this.view.$t('Message.NoForeignFeeBilling'))
      return
    }

    // 结算对象
    const accountMap = {}
    const accounts = []
    // 结算代理
    const settlementMap = {}
    const settlements = []
    for (const charge of this._billingCharges) {
      const accountId = charge.accountId
      if (accountId && !accountMap[accountId]) {
        accountMap[accountId] = true
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', accountId)
        if (company) {
          accounts.push(company)
        }
      }
      const settlementAgentId = charge.settlementAgentId
      if (settlementAgentId && !settlementMap[settlementAgentId]) {
        settlementMap[settlementAgentId] = true
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', settlementAgentId)
        if (company) {
          settlements.push(company)
        }
      }
    }
    if (accounts.length > 1 || settlements.length > 1) {
      this.view.settlementSelectDialog.accounts = accounts
      this.view.settlementSelectDialog.settlements = settlements
      this.view.settlementSelectDialog.title = this.view.$t('Message.SelectTheBillingObject')
      this.view.settlementSelectDialog.visible = true
    } else if (accounts.length === 1) {
      this.openBillingWindow(accounts[0].cmpIdx, 0)
    } else {
      this.$message.warning(this.view.$t('Message.NoSettlementUnit'))
    }
  }
  async openBillingWindow(accountId, createBillWay) {
    const customer = await Company.getCompanyById(accountId)
    if (customer === null) {
      this.$message.warning(this.view.$t('Message.CheckoutObjectIsNullNoAdditionalCostsConfirmationSlip'))
      return
    }
    // CARGO-24198 账单里没有正常显示费用
    const currentOfficeId = this.view.$store.getters.currentOfficeId
    if (this._billingCharges && this._billingCharges.length > 0) {
      // 1. 判断当前分公司是否与费用的branchID一致，
      let isSameBranchId = true
      for (const charge of this._billingCharges) {
        if (charge.branchId !== currentOfficeId) {
          isSameBranchId = false
          break
        }
      }
      // 2.若不一致，判断参数：可查看下级公司财务数据QueryChildernDataRole
      if (!isSameBranchId) {
        // 3.是否可查看下级公司财务数据QueryChildernDataRole是否开启
        const queryChildernDataRole = parseInt(cache.config.get('QueryChildernDataRole'))
        if (queryChildernDataRole === 1) { // 可以查看时，判断当前分公司是否是费用branchID的上级公司
          let checkBranch = true
          for (const charge of this._billingCharges) {
            checkBranch = await SecurityUtil.checkChargeDetailBranch(charge.branchId)
            if (!checkBranch) {
              break
            }
          }
          // 4.若不是，不允许创建。
          if (!checkBranch) {
            this.view.$message.warning(this.view.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
            return
          }
        } else {
          // 5.参数未开启，不允许创建账单
          this.view.$message.warning(this.view.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
          return
        }
      }
    }

    let flag = false
    let statusFlag = false
    const statusData = []
    for (const charge of this._billingCharges) {
      // 状态-全部核销
      if (charge['amount'] !== 0 && charge['verifiedAmount'] === charge['amount']) {
        flag = true
      } else {
        statusFlag = true
        statusData.push(charge)
      }
    }
    let selectedNo = false
    let closeConfirm = false
    if (flag) {
      await this.$confirm(this.view.$t('Message.SelectedExpensesIncludeAllWriteOffExpensesWhetherToAddThemToTheBill'), this.view.$t('Message.Prompt'), {
        confirmButtonText: this.view.$t('common.btn.ok'),
        cancelButtonText: this.view.$t('common.btn.cancel'),
        distinguishCancelAndClose: true,
        type: 'warning'
      }).then(() => {}).catch((action) => {
        if (action === 'close') {
          closeConfirm = true
        } else {
          if (statusFlag) {
            this._billingCharges = statusData
          } else {
            selectedNo = true
          }
        }
      })
    }
    if (selectedNo) {
      this.$message.warning(this.view.$t('Message.AllSelectedFeesWillBeVerifiedPleaseChooseAgain'))
      return
    }
    if (closeConfirm) {
      return
    }
    // _billingCharges 根据实际剩下的费用获取结算单位
    this._billingChargeAccountcodes = []
    const accountIdMap = {}
    for (const charge of this._billingCharges) {
      if (!accountIdMap.hasOwnProperty(charge.accountId)) {
        const o = {}
        o.label = await Company.getCompanyName(charge.accountId)
        o.data = charge.accountId
        if (createBillWay) {
          if (Number(charge.settlementAgentId) === accountId) {
            this._billingChargeAccountcodes.push(o)
            accountIdMap[charge.accountId] = charge.accountId
          }
        } else {
          this._billingChargeAccountcodes.push(o)
          accountIdMap[charge.accountId] = charge.accountId
        }
      }
    }
    const billing = await this.getBilling(accountId, createBillWay)
    if (this._billingCharges && this._billingCharges.length > 0) {
      if (this._billingCharges.length === 1) {
        billing.title = this._billingCharges[0]['invoiceTitle']
      } else {
        for (const charge of this._billingCharges) {
          if (billing.accountId && billing.accountId === charge.accountId) {
            billing.title = charge['invoiceTitle']
            billing.settlementAgentId = charge['settlementAgentId']
            break
          }
        }
      }
    }
    billing.settlementAgentId = createBillWay ? accountId : billing.settlementAgentId
    billing.createBillWay = createBillWay
    this.view.overseaBillingDialog.createBillWay = createBillWay

    //   国外费用弹出窗
    this.view.overseaBillingDialog.currentBillingBranchId = (this.enableCommission && this.currentBillingBranchId > 0) ? this.currentBillingBranchId : 0
    this.view.overseaBillingDialog.departmentTeamUser = this.departmentTeamUser
    this.view.overseaBillingDialog.isAddBillTaxAmount = this.isAddBillTaxAmount
    this.view.overseaBillingDialog.debitChargetaxRate = this.debitChargetaxRate
    this.view.overseaBillingDialog.billingChargeDetail = this._billingCharges
    this.view.overseaBillingDialog.billingChargeAccounts = this._billingChargeAccountcodes
    this.view.overseaBillingDialog.propBilling = billing
    this.view.overseaBillingDialog.propBilling.charge = [] // 新增账单时 增加此属性
    this.view.overseaBillingDialog.job = this.job
    this.view.overseaBillingDialog.instructionBtns = []
    const company = await Company.getCompanyById(billing.accountId)
    const customerDetail = await new Company(company).getCustomerDetail()
    // 合作伙伴是否开启按费用拆分账单
    if (customerDetail && customerDetail.currencyRequirements > 1) {
      // 设置指定币种时 调整账单默认币种
      if (customerDetail.currencyRequirements === 2 && customerDetail.appointCurrency) {
        this.view.overseaBillingDialog.propBilling.currency = customerDetail.appointCurrency
      }
      this.view.newOverseaBillingDialog.customerDetail = customerDetail
      this.view.newOverseaBillingDialog.visible = true
    } else {
      this.view.overseaBillingDialog.visible = true
    }
  }
  async getBilling(accountId = 0, createBillWay = 0) {
    // CARGO-36110 新增国外账单，选择的结算对象和展现的不一致
    const _billing = new Billing().fillDefaultValue().getData()
    // CARGO-36110 新增国外账单，选择的结算对象和展现的不一致
    if (createBillWay) { // 按结算代理生成账单，结算对象随机取一个
      if (this._billingChargeAccountcodes.length > 0) {
        _billing.accountId = this._billingChargeAccountcodes[0].data
        const accountCompany = await Company.getCompanyById(_billing.accountId)
        if (accountCompany) {
          _billing.accountAddr = accountCompany.accountAddr
        }
      }
    } else { // 按结算对象生成账单，要根据选择的结算对象进行生成
      _billing.accountId = accountId
    }
    _billing.billingType = BillingConstants.BILLING_TYPE_OVERSEA.code
    _billing.inputBy = cache.user.userId
    _billing.state = -1
    _billing.inputDate = moment(new Date()).format('yyyy-MM-DD')
    _billing.currency = this._billingCharges[0].currency
    _billing.makeInvoiceType = 0
    _billing.invoiceRemark = ''
    _billing.invoiceUsdRemark = ''
    _billing.remarkAddContent = ''
    _billing.detailMakeInvoice = true
    _billing.splitMakeInvoice = true
    _billing.billingBeforehandVOS = []
    const localCurrency = RateUtil.localCurrencyByOfficeId(this.job.opOffice)
    if (this.isSaveBillRate === 1) {
      _billing.rate = await BillingRateUtil.getForeignExchangeRateSafely(localCurrency, _billing.currency, _billing.inputDate)
    } else {
      _billing.rate = await RateUtil.getForeignExchangeRateSafely(localCurrency, _billing.currency, _billing.inputDate, this.job.opOffice)
    }
    _billing.rate = NumberUtils.roundHalfUp(_billing.rate, 8) // CARGO-7779
    return _billing
  }

  getJobCharges(charges) {
    for (const charge of charges) {
      if (RateUtil.useOrderCenterMode() && charge.branchId !== this.$store.getters.currentOfficeId) {
        continue
      }
      if (!charge.billingUuid && charge.oversea && charge.offsetState === 0 && !charge.shared) {
        // CARGO-2666，业务详情-账单：费用所属分公司
        if (!this.enableCommission) {
          this._billingCharges.push(charge)
        } else {
          if (this.showSpecialCharge && this.currentBillingBranchId > 0) {
            if (charge.branchId === this.currentBillingBranchId) {
              this._billingCharges.push(charge)
            }
          } else {
            if (charge.branchId === this.view.$store.getters.currentOfficeId) {
              this._billingCharges.push(charge)
            }
          }
        }
      }
    }
  }

  getUserDepartmentTeamHandler(data) {
    if (data != null) {
      this.departmentTeamUser = data
    }
    this._billingCharges = this.getDepartRoleBillingCharges()
    this.checkRoleBillingCharge()
  }

  /**
 * 当前job费用是否是自己创建的
 */
  checkChargeCreatedBy() {
    for (const charge of this.job.charges) {
      if (charge.createdBy !== this.view.user.userId) {
        return false
      }
    }

    return true
  }

  /**
   * 编辑
   */
  async onEditClickEvent(instructioinBtns) {
    const _job = this.job

    // CARGO-34566 国外账单可在非【正操作】状态编辑/删除
    // if (_job.jobState !== 0) {
    //   this.$message.warning(this.view.$t('Message.ThisJobIsNotWorkingCanNotBeEdited'))
    //   return
    // }
    if (this.selectedBilling === null) {
      return
    }
    const _t_billing = this.selectedBilling
    if (_t_billing.billingType === BillingConstants.BILLING_TYPE_OVERSEA.code) {
      if (this.view.viewSource && this.view.viewSource === 'salesDetail') {
        if (_t_billing.billingGroupUuid) {
          this.$message.warning(this.view.$t('CargoMsg.Cargo_HasBillingGroup'))
          return
        }
        if (_t_billing.confirmed) {
          this.$message.warning(this.view.$t('CargoMsg.Cargo_HasConfirm'))
          return
        }
        if (_t_billing.charge && _t_billing.charge.length > 0) {
          for (const charge of _t_billing.charge) {
            if (charge.invoiceUuid) {
              this.$message.warning(this.view.$t('CargoMsg.Cargo_HasInvoice'))
              return
            }
            if (charge.verifiedAmount > 0) {
              this.$message.warning(this.view.$t('CargoMsg.Cargo_HasWriteOff'))
              return
            }
          }
        }
      }
      this.view.overseaBillingDialog.currentBillingBranchId = (this.enableCommission && this.currentBillingBranchId > 0) ? this.currentBillingBranchId : 0
      this.view.overseaBillingDialog.departmentTeamUser = this.departmentTeamUser
      this.view.overseaBillingDialog.job = _job
      this._billingChargeAccountcodes = []
      const o = {}
      o.label = await Company.getCompanyName(Number(_t_billing.accountId))
      o.data = _t_billing.accountId
      this._billingChargeAccountcodes.push(o)

      const loading = getLoading4Cxt(this.view)
      try {
        this._billingCharges = await BillingUtils.getBillTabCharges(this.view, this.job, false, true, {
          enableCommission: this.enableCommission,
          showSpecialCharge: this.showSpecialCharge,
          currentBillingBranchId: this.currentBillingBranchId,
          viewSource: this.view.viewSource,
          departmentTeamUser: this.departmentTeamUser
        }) || []
        loading.close()
      } catch {
        loading.close()
      }

      this.view.overseaBillingDialog.currentBillingBranchId = (this.enableCommission && this.currentBillingBranchId > 0) ? this.currentBillingBranchId : 0
      this.view.overseaBillingDialog.departmentTeamUser = this.departmentTeamUser
      this.view.overseaBillingDialog.isAddBillTaxAmount = this.isAddBillTaxAmount
      this.view.overseaBillingDialog.debitChargetaxRate = this.debitChargetaxRate
      this.view.overseaBillingDialog.billingChargeDetail = this._billingCharges
      this.view.overseaBillingDialog.billingChargeAccounts = this._billingChargeAccountcodes
      this.view.overseaBillingDialog.propBilling = _t_billing
      this.view.overseaBillingDialog.job = this.job
      this.view.overseaBillingDialog.createBillWay = _t_billing.createBillWay
      if (this.view.overseaBillingDialog.createBillWay === 1) {
        this.view.searchItemModule = '5044'
      }
      this.view.overseaBillingDialog.instructionBtns = instructioinBtns || []
      // CARGO-7869 标识修改国外账单
      this.view.overseaBillingDialog.isAddOrEdit = true
      this.view.overseaBillingDialog.visible = true
    } else if (_t_billing.billingType === BillingConstants.BILLING_TYPE_AGENT.code) {
      // 需要重新加载最新的费用信息
      if (_t_billing.uuid) {
        await loadAgentRelationCharge(_t_billing.uuid).then(async(res) => {
          _t_billing.agentCharge = res.data
        })
        await getAgentSharedCharge(_t_billing.uuid).then(res => {
          _t_billing.agentSharedCharge = res.data
        })
      }
      this.view.agencyShareBillDialog.propBilling = _t_billing
      this.view.agencyShareBillDialog.job = this.job
      this.view.agencyShareBillDialog.currentBillingBranchId = (this.enableCommission && this.currentBillingBranchId > 0) ? this.currentBillingBranchId : 0
      this.view.agencyShareBillDialog.visible = true
    }
  }
  editCloseCallBackFun() {
    this.getChargeByBillingNo()
    this.loadBilling()
  }

  getChargeByBillingNo(_billing = null, _accountcode = null) {
    this._billingCharges = []
    if (!_billing) {
      return
    }
    for (const charge of this.job.charges) {
      if (RateUtil.useOrderCenterMode() && charge.branchId !== this.$store.getters.currentOfficeId) {
        continue
      }
      if (charge.billingUuid === _billing.uuid && (!_accountcode || String(charge.accountId) === _accountcode) && charge.oversea && !charge.paidOff) {
        this._billingCharges.push(charge)
      }
    }
  }
  /**
   * 删除
   */
  onDelClickEvent() {
    const bill = this.selectedBilling
    const chooseRows = this.view.up.gridApi.getSelectedRows()
    if (chooseRows.length === 0 && !bill) {
      this.$message.warning(this.$t('act.billing.pleaseSelectBilling'))
      return
    }
    if (chooseRows.length === 0) {
      chooseRows.push(bill)
    }
    // 是否只有仅删除个人的权限
    const onlyDeleteBySelf = !this.deleteByAll && !this.deleteByDep && this.deleteBySelf
    for (let i = 0; i < chooseRows.length; i++) {
      const billing = chooseRows[i]
      if (!this.$checkPermission(['button_InternalBillInfo_payAdd']) && !billing.ar) {
        this.$message.warning(this.view.$t('Message.YouDontHavePermissionToDeleteBills'))
        return
      }
      if (onlyDeleteBySelf && (billing.createdBy || billing.inputBy) !== this.user.userId) {
        if (billing.billingNo) {
          this.$message.warning(this.view.$t('Message.HaveNoPermissionToDeleteBillsCreatedByOtherUsers') + ' [' + billing.billingNo + ']')
        } else {
          this.$message.warning(this.view.$t('Message.HaveNoPermissionToDeleteBillsCreatedByOtherUsers'))
        }
        return
      }
      if (billing.billingType === BillingConstants.BILLING_TYPE_OVERSEA.code &&
          (![BillingConstants.BILLING_NOT_PRINTED.code, BillingConstants.BILLING_INVOICED.code].includes(billing.state) ||
              billing.confirmed)) { // 国外账单
        if (billing.billingNo) {
          this.$message.warning(this.$t('act.billing.hasConfirmed', [billing.billingNo]))
        } else {
          this.$message.warning(this.$t('CargoMsg.Cargo_BillConfirmed'))
        }
        return
      }
      if (billing.billingType === BillingConstants.BILLING_TYPE_AGENT.code && billing.confirmed) { // 代理分成账单
        if (billing.billingNo) {
          this.$message.warning(this.$t('act.billing.hasConfirmed', [billing.billingNo]))
        } else {
          this.$message.warning(this.$t('CargoMsg.Cargo_BillConfirmed'))
        }
        return
      }
      if (billing.billingGroupUuid) {
        this.$message.warning(this.$t('act.billing.hasBillingGroup', [billing.billingNo]))
        return
      }
      if (billing.invoiceState > 0) {
        this.$message.warning(this.$t('act.billing.hasInvoice', [billing.billingNo]))
        return
      }
      if (billing.realClearingState > 0) {
        this.$message.warning(this.$t('act.billing.hasWriteOff', [billing.billingNo]))
        return
      }
      if (billing.state > BillingConstants.BILLING_NORMAL.code || billing.billingNo) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DeleteBillTips'))
        return
      }
      // CARGO-24939，接收付款信息进行账单锁定
      if (billing.ocPaymentLock !== undefined && billing.ocPaymentLock) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DeleteOCBillTips'))
        return
      }
      if (billing.review === 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DeleteRecheckedBillTips'))
        return
      }
    }
    return this.$confirm(this.$t('act.billing.confirmDelete', [chooseRows.length]), this.$t('common.tips.prompt'), {
      confirmButtonText: this.$t('common.btn.ok'),
      cancelButtonText: this.$t('common.btn.cancel'),
      type: 'warning'
    }).then(() => {
      const ids = []
      for (const item of chooseRows) {
        ids.push(item.uuid)
      }
      this.loading = getLoading()
      batchDelBilling(ids, this.view.location).then(res => {
        this.$message.success(this.view.$t('Message.DeleteSuccessfully'))
        const job = this.getJobByLob()
        job.charges = ''
        job.getCharges()
        this.loadBilling()
        this.onBillingGridItemClick()
        this.context.reloadCharge = true
      }).finally(() => {
        this.loading.close()
      })
    }).catch(() => {
    })
  }
  deleleBillingResultHandler(data) {
    // 实现 onCancelAlertClickHandler
    const billing = this.selectedBilling
    //  调用api
    deleteBilling({ billKey: billing.uuid, location: this.view.location }).then(res => {
      //  刷新费用 tab
      // dispatchEvent(new Event("refreshChargeTab"));
      const job = this.getJobByLob()
      job.charges = ''
      job.getCharges()

      this.loadBilling()
      this.onBillingGridItemClick()
      this.context.reloadCharge = true
    })
  }

  /**
   * 审核
   */
  onAutidClickEvent() {
    const bill = this.selectedBilling
    const _job = this.job
    if (_job.jobState !== 0) {
      this.$message.warning(this.view.$t('Message.ThisJobIsNotWorkingCanNotBeEdited'))
      return
    }

    this.$confirm(this.view.$t('Message.SureAuditTheBill'), this.view.$t('common.tips.prompt'), {
      confirmButtonText: this.view.$t('common.btn.ok'),
      cancelButtonText: this.view.$t('common.btn.cancel'),
      type: 'warning'
    }).then(() => {
      if (bill && bill.state === 0) {
        this.confrimLoadBillingChargeHandler()
      }
    })
  }

  confrimLoadBillingChargeHandler() {
    const bill = this.selectedBilling
    // 调用api 后端 审核 或保存 前端逻辑移至后端
    autidBilling({ billKey: bill.uuid }).then(async() => {
      // autidBillingResultHandler
      this.$message.success(this.view.$t('Message.AuditSuccessfully'))
      await this.loadBilling()
      this.selectedBilling = this.view.billingList.find(p => p.uuid === bill.uuid)
      await this.onBillingGridItemClick({ data: this.selectedBilling })
      // 设置选中行
      this.$nextTick(() => {
        this.setGridSelect(this.selectedBilling)
      })
      this.buttonStateControl()
    })
  }

  /**
   * 设置 选中行
   * @param selectRow
   */
  setGridSelect(selectRow) {
    const nodes = this.view.up.gridApi.getRenderedNodes()
    for (const item of nodes) {
      if (!item.data) {
        continue
      }
      if (item.data.uuid === selectRow.uuid || !item.data.uuid) {
        item.setSelected(true)
        break
      }
    }
  }
  /**
   * 作废
   */
  onInvaidClickEvent() {
    const _job = this.job
    if (_job.jobState !== 0) {
      this.$message.warning(this.view.$t('Message.ThisBillWasSubmittedToTheFinancialAuditAndCannotBeVoided'))
      return
    }
    const selectedRows = this.view.up.gridApi ? this.view.up.gridApi.getSelectedRows() : []
    let warnBillNos = []
    const warnMsgSet = new Set()
    const billKeys = []
    for (const row of selectedRows) {
      if (row.review !== 0) {
        warnBillNos.push(row.billingNo)
        warnMsgSet.add(this.view.$t('queryJob.Reviewed'))
        continue
      }
      if (row.ocPaymentLock) {
        warnBillNos.push(row.billingNo)
        warnMsgSet.add(this.view.$t('Message.Locked'))
        continue
      }
      if (row.invoiceState > 0) {
        warnBillNos.push(row.billingNo)
        warnMsgSet.add(this.view.$t('CargoMsg.Cargo_Invoiced'))
        continue
      }
      if (this.enableCommission) {
        if (row.state !== 2) {
          warnBillNos.push(row.billingNo)
          warnMsgSet.add(this.view.$t('queryJob.NotPrintedState'))
          continue
        }
      } else {
        if (row.state === 3) {
          warnBillNos.push(row.billingNo)
          warnMsgSet.add(this.view.$t('CargoMsg.Cargo_Voided'))
          continue
        }
        if (row.state > 3) {
          warnBillNos.push(row.billingNo)
          warnMsgSet.add(this.view.$t('Message.Locked'))
          continue
        }
      }
      if (row.paymentState > 0) {
        warnBillNos.push(row.billingNo)
        warnMsgSet.add(this.view.$t('queryJob.ApplicationPayInitiated'))
        continue
      }
      if (row.billingGroupUuid) {
        warnBillNos.push(row.billingNo)
        warnMsgSet.add(this.view.$t('queryJob.StatementGenerated'))
        continue
      }
      if (row.realClearingState !== ClearingConstants.CLEARING_STATE_NON.code) {
        warnBillNos.push(row.billingNo)
        warnMsgSet.add(this.view.$t('Billing.HasWriteOff'))
        continue
      }
      if (row.confirmed) {
        warnBillNos.push(row.billingNo)
        warnMsgSet.add(this.view.$t('Message.Confirmed'))
        continue
      }
      if (row.revoked) {
        warnBillNos.push(row.billingNo)
        warnMsgSet.add(this.view.$t('CargoMsg.Cargo_Voided'))
        continue
      }
      billKeys.push(row.uuid)
    }
    if (warnBillNos.length > 0) {
      warnBillNos = Array.from(warnBillNos, p => p || ' ')
      this.$confirm(this.view.$t('queryJob.BillCannotVoid', [`{${warnBillNos.join(',')}}`, `{${[...warnMsgSet].join('、')}}`]), this.view.$t('common.tips.prompt'), {
        confirmButtonText: this.view.$t('Message.Close'),
        showCancelButton: false,
        type: 'warning'
      })
      return
    }
    this.reloadResultHandler(billKeys)
  }

  reloadResultHandler(billKeys) {
    // 实现onInvalidClickHandler
    this.$confirm(this.view.$t('Message.ConfirmTheCancellationOfTheBill2'), this.view.$t('common.tips.prompt'), {
      confirmButtonText: this.view.$t('common.btn.ok'),
      cancelButtonText: this.view.$t('common.btn.cancel'),
      type: 'warning'
    }).then(() => {
      // 调用api
      invalidBilling({ billKeys: billKeys.join(','), location: this.view.location }).then(async() => {
        this.$message.success(this.view.$t('Message.TheBillHasBeenRevoked'))
        await this.loadBilling()
        // this.selectedBilling = this.view.billingList.find(p => p.uuid === bill.uuid)
        // await this.onBillingGridItemClick({ data: this.selectedBilling })
        // // 设置选中行
        // this.setGridSelect(this.selectedBilling)
        // this.buttonStateControl()
      })
    })
  }
  forceDelResultHandler(data) {
    const bill = data
    if (bill.state > 3) {
      this.$message.warning(this.view.$t('Message.ThisFormIsLockedAndCannotBeForceDel'))
      return
    }

    this.$confirm(this.view.$t('Message.ConfirmTheForceDelOfTheBill'), this.view.$t('common.tips.prompt'), {
      confirmButtonText: this.view.$t('common.btn.ok'),
      cancelButtonText: this.view.$t('common.btn.cancel'),
      type: 'warning'
    }).then(() => {
      this.onForceDelClickHandler()
    })
  }
  onForceDelClickHandler() {
    const _billing = this.selectedBilling
    let charge = null
    if (_billing.billingType === BillingConstants.BILLING_TYPE_OVERSEA.code) {
      for (let i = _billing.charge.length - 1; i >= 0; i--) {
        charge = _billing.charge[0]
        charge.billNo = null
        charge.billing = null
        charge.billingDate = null
        if (this.invoiceSyncRate === 1) {
          charge.chargeState = ChargeConstants.STATE_UNCOMMIT.code
        }
      }
    } else if (_billing.billingType === '代理分成账单') {
      for (let j = _billing.charge.length - 1; j >= 0; j--) {
        charge = _billing.charge[0]
        charge.billNo = null
        charge.billing = null
        charge.billingDate = null
        charge.job = null
      }
    }
    // 删除前端逻辑移至后端
    this.forceDelBillingResultHandler()
  }
  forceDelBillingResultHandler() {
    this.$message.success(this.view.$t('Message.ForceDelSuccessfully'))
    // todo 刷新费用tab页签
    //  dispatchEvent(new Event("refreshChargeTab"));
    //  _job.reload2
    this.loadBilling()
    this.onBillingGridItemClick()
  }
  /**
   * 代理分成账单 创建
   */
  onAgentClickEvent() {
    const _job = this.job
    if (_job.jobState === 3 && _job.shutOut === 1) {
      this.$message.info('业务已退关，不能操作')
      return
    }
    this.getChargeByBillingNo()

    const _billing = new Billing().fillDefaultValue().getData()
    _billing.branchId = RateUtil.useOrderCenterMode() ? this.$store.getters.currentOfficeId : _job.opOffice
    _billing.titleBranchId = RateUtil.useOrderCenterMode() ? this.$store.getters.currentOfficeId : _job.opOffice
    _billing.billingType = BillingConstants.BILLING_TYPE_AGENT.code
    _billing.settlementType = 0
    _billing.state = 0
    _billing.inputDate = new Date()
    _billing.inputBy = this.user.userId
    _billing.currency = 'USD'
    _billing.amount = 0
    _billing.percentage = 100

    // 起运港、目的港、中转港、MBL号、开船日期、客户编号
    _billing.pol = _job.loadingPortCode
    _billing.pod = _job.destinationPortCode
    _billing.pod2 = _job.dischargingPortCode
    _billing.mbl = _job.mbl
    _billing.ETD = _job.etd
    _billing.ETA = _job.eta
    _billing.jobUuid = _job.uuid
    _billing.jobNo = _job.jobNo
    if (this.view.viewSource === 'SeaBooking' && _job.destinationAgent) {
      _billing.accountId = _job.destinationAgent
    }

    _billing.agentSharedCharge = []
    _billing.agentCharge = []
    this.view.agencyShareBillDialog.propBilling = _billing
    this.view.agencyShareBillDialog.job = _job
    this.view.agencyShareBillDialog.currentBillingBranchId = (this.enableCommission && this.currentBillingBranchId > 0) ? this.currentBillingBranchId : 0
    this.view.agencyShareBillDialog.visible = true
  }
  onPrintAllAgentClickEvent() {
    if (this.job === null) { return }
    const params = {}
    params.jobuuid = this.job.uuid
    params.JOB_UUID = this.job.uuid
    this.view.templateSelectorDialog.ctx = this.getJobByLob()
    this.view.templateSelectorDialog.category = 'AGENT_SHARING_BILLING'
    this.view.templateSelectorDialog.data = params
    this.view.templateSelectorDialog.visible = true
  }

  /**
   * 编辑代理账单号
   */
  onEditAgentBillNoClickEvent() {
    const _billing = this.selectedBilling
    if (_billing.billingType !== BillingConstants.BILLING_TYPE_OVERSEA.code) {
      this.$message.info('请选择国外账单.')
      return
    }
    this.view.editAgentBillNoDialog.visible = true
  }

  /**
   * 显示所有账单
   */
  showAllBillingChangeHandler() {
    LocalStorageUtils.setConfiguration(SHOW_BILLING_CACHE_KEY, this.view.cbShowAllBilling)
    this.loadBilling()
  }

  /**
   * 仅显示本委托费用
   */
  showSelfChargeChangeHandler() {
    LocalStorageUtils.setConfiguration(SHOW_SELF_CACHE_KEY, this.view.cbShowSelfChanges)
    this.loadBillingChargeHandler()
  }

  /**
   * 账单所属分公司
   */
  onBillingBranchIdHandler(value) {
    if (StrUtils.isEmpty(value)) {
      return
    }
    this.currentBillingBranchId = value
    if (this.currentBillingBranchId > 0) {
      LocalStorageUtils.setConfiguration('specialBillingBranchId', this.currentBillingBranchId)
      this.loadBilling()
    }
  }

  /**
   * 刷新表格并清除选中
   */
  refreshGrid() {
    if (this.view.up.gridApi) {
      this.view.up.gridApi.refreshCells({ force: true })
      this.view.up.gridApi.clearFocusedCell()
      this.view.selectedBilling = null
      this.view.selectedDataList = []
    }
  }

  /**
   * 确认 账单
   */
  btnConfrimClickHandler() {
    const bill = this.selectedBilling
    const chooseRows = this.view.up.gridApi.getSelectedRows()
    const keys = []
    for (let i = 0; i < chooseRows.length; i++) {
      const billing = chooseRows[i]
      if (billing.revoked) {
        this.$message.warning(this.$t('queryJob.InvalidBillCannotConfirm'))
        return
      }
      const state = billing.state
      if ((state === Number(BillingConstants.BILLING_NORMAL.code) || !billing.confirmed) && !billing.billingGroupUuid) {
        keys.push({ 'key': billing.uuid, 'version': billing.version })
      }
    }
    if (keys.length === 0 && !bill) {
      this.$message.warning(this.$t('act.billing.noConfirmBill'))
      return
    }
    if (keys.length === 0) {
      const state = bill.state
      if ((state === Number(BillingConstants.BILLING_NORMAL.code) || !bill.confirmed) && !bill.billingGroupUuid) {
        keys.push({ 'key': bill.uuid, 'version': bill.version })
      } else {
        this.$message.warning(this.$t('act.billing.noConfirmBill'))
        return
      }
    }
    this.$confirm(this.$t('act.billing.batchConfirmBill', [keys.length]), this.$t('common.tips.prompt'), {
      confirmButtonText: this.$t('common.btn.ok'),
      cancelButtonText: this.$t('common.btn.cancel'),
      type: 'warning'
    }).then(() => {
      return batchConfirmBilling(keys, this.view.location).then(res => {
        this.$message.success(this.$t('act.billing.confirmSuccess'))
        this.confrimBillHandler()
      })
    }).catch(() => {
    })
  }

  btnConfirmHandle(keys) {
    batchConfirmBilling(keys, this.view.location).then(res => {
      this.$message.success(this.$t('act.billing.confirmSuccess'))
      this.confrimBillHandler()
    })
  }

  confrimBillHandler() {
    this.loadBilling()
    this.buttonStateControl()
  }

  /**
   * 复核
   */
  btnRecheckBillingHandler() {
    const chooseRows = this.view.up.gridApi.getSelectedRows()
    const billing = this.selectedBilling
    let billings = []
    if (chooseRows && chooseRows.length !== 0) {
      billings = [...chooseRows]
    } else if (billing) {
      billings.push(billing)
    }
    if (billings.length === 0) {
      this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
      return
    }
    recheckBilling(billings).then(() => {
      this.loadBilling()
      this.$message.success(this.view.$t('CargoMsg.Cargo_ReCheckedSuccessfully'))
      this.buttonEnabledControl()
    })
  }

  btnRecheckHandle(billings) {
    recheckBilling(billings).then(() => {
      this.loadBilling()
      this.$message.success(this.view.$t('CargoMsg.Cargo_ReCheckedSuccessfully'))
      this.buttonEnabledControl()
    })
  }

  /**
   * 取消复核
   */
  btnCancelRecheckBillingHandler() {
    const chooseRows = this.view.up.gridApi.getSelectedRows()
    const billing = this.selectedBilling
    let billings = []
    if (chooseRows && chooseRows.length !== 0) {
      billings = [...chooseRows]
    } else if (billing) {
      billings.push(billing)
    }
    if (billings.length === 0) {
      this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
      return
    }
    cancelRecheckBilling(billings).then(() => {
      this.loadBilling()
      this.$message.success(this.view.$t('CargoMsg.Cargo_CancelReCheckedSuccessfully'))
      this.buttonEnabledControl()
    })
  }

  /**
   * 取消确认
   */
  btnCancelConfrimHandler() {
    const bill = this.selectedBilling
    const chooseRows = this.view.up.gridApi.getSelectedRows()
    const keys = []
    for (let i = 0; i < chooseRows.length; i++) {
      const billing = chooseRows[i]
      const state = billing.state
      if ((state >= Number(BillingConstants.BILLING_VERIFIED.code) || billing.confirmed) && !billing.billingGroupUuid && billing.review === 0) {
        keys.push({ 'key': billing.uuid, 'version': billing.version })
      }
    }
    if (keys.length === 0 && !bill) {
      this.$message.warning(this.$t('act.billing.noCancelConfirmBill'))
      return
    }
    if (keys.length === 0) {
      const state = bill.state
      if ((state >= Number(BillingConstants.BILLING_VERIFIED.code) || bill.confirmed) && !bill.billingGroupUuid && bill.review === 0) {
        keys.push({ 'key': bill.uuid, 'version': bill.version })
      } else {
        this.$message.warning(this.$t('act.billing.noCancelConfirmBill'))
        return
      }
    }
    this.$confirm(this.$t('Message.CancelConfirmBill'), this.$t('common.tips.prompt'), {
      confirmButtonText: this.$t('common.btn.yes'),
      cancelButtonText: this.$t('common.btn.no'),
      type: 'warning',
      distinguishCancelAndClose: true
    }).then(() => {
      batchUnConfirmBilling(keys, true, this.view.location).then(res => {
        this.$message.success(this.$t('act.billing.cancelConfirmSuccess'))
        this.confrimBillHandler()
      }).finally(() => {
      })
    }).catch((e) => {
      if (e === 'cancel') {
        batchUnConfirmBilling(keys, false, this.view.location).then(res => {
          this.$message.success(this.$t('act.billing.cancelConfirmSuccess'))
          this.confrimBillHandler()
        }).finally(() => {
        })
      }
    })
  }
  // 同组部门费用过滤
  getDepartRoleBillingCharges() {
    const charges = []
    if (this._billingCharges && this._billingCharges.length > 0) {
      for (const charge of this._billingCharges) {
        if (this.checkDepartmentTeam(charge)) {
          if (!this.enableCommission) {
            charges.push(charge)
          } else {
            if (this.showSpecialCharge && this.currentBillingBranchId > 0) {
              if (charge.branchId === this.currentBillingBranchId) {
                charges.push(charge)
              }
            } else {
              if (charge.branchId === this.view.$store.getters.currentOfficeId) {
                charges.push(charge)
              }
            }
          }
        }
      }
    }
    return charges
  }
  // 同组费用查看
  checkDepartmentTeam(charge) {
    if (charge.createdBy === this.view.$store.getters.userId) {
      return true
    }
    for (const userId of this.departmentTeamUser) {
      if (userId === charge.createdBy) {
        return true
      }
    }
    return false
  }
  // 强制删除
  async forceDeleteHandler() {
    const bill = this.selectedBilling
    const chooseRows = this.view.up.gridApi.getSelectedRows() || []
    if ((chooseRows && chooseRows.length > 0) || bill) {
      const keys = []
      if (!chooseRows || chooseRows.length === 0) {
        chooseRows.push(bill)
      }
      for (const billing of chooseRows) {
        keys.push(billing.uuid)
        if ((billing.state !== BillingConstants.BILLING_NOT_PRINTED.code || billing.state !== BillingConstants.BILLING_NORMAL.code) && billing.state === BillingConstants.BILLING_VERIFIED.code &&
            billing.state === BillingConstants.BILLING_INVOICED.code && billing.state === BillingConstants.BILLING_INVALID.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ForceDeleteBillTips'))
          return
        }
      }
      const validate = await this.validateForceDeleteBilling(keys)
      if (validate) {
        this.$confirm(this.$t('act.billing.confirmDelete', [chooseRows.length]), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }).then(() => {
          this.loading = getLoading()
          forceDeleteBilling(keys, this.view.location).then(res => {
            this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
            const job = this.getJobByLob()
            job.charges = ''
            job.getCharges()
            this.loadBilling()
            this.onBillingGridItemClick()
            this.context.reloadCharge = true
          }).finally(() => {
            this.loading.close()
          })
        }).catch(() => {
        })
      }
    } else {
      this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
    }
  }
  async validateForceDeleteBilling(keys = []) {
    this.loading = getLoading()
    const data = await validateForceDeleteBilling(keys).then(res => { return res.data }).finally(() => { this.loading.close() })
    if (data.billingNo) {
      let msg = ''
      if (data.hasInvoice) {
        if (msg) {
          msg = msg + this.$t('CargoMsg.Cargo_Invoiced')
        } else {
          msg = this.$t('CargoMsg.Cargo_Invoiced')
        }
      }
      if (data.hasBillPayment) {
        if (msg) {
          msg = msg + '/' + this.$t('Billing.HasBillPayment')
        } else {
          msg = this.$t('Billing.HasBillPayment')
        }
      }
      if (data.hasBillingGroup) {
        if (msg) {
          msg = msg + '/' + this.$t('Billing.HasBillingGroup')
        } else {
          msg = this.$t('Billing.HasBillingGroup')
        }
      }
      if (data.hasWriteOff) {
        if (msg) {
          msg = msg + '/' + this.$t('Billing.HasWriteOff')
        } else {
          msg = this.$t('Billing.HasWriteOff')
        }
      }
      if (data.hasClosingAccount) {
        if (msg) {
          msg = msg + '/' + this.$t('Billing.HasClosingAccount')
        } else {
          msg = this.$t('Billing.HasClosingAccount')
        }
      }
      this.$message.warning(this.$t('Billing.ForceDeleteBilling', [data.billingNo, msg]))
      return false
    }
    return true
  }
  // 获取job
  getJobByLob() {
    let job = null
    if (this.job && this.job.lob === 'SI') {
      job = new SeaImportJob(this.job)
    } else if (this.job && this.job.lob === 'AI') {
      job = new AirImportJob(this.job)
    } else if (this.job && this.job.lob === 'AE') {
      job = new AirExportJob(this.job)
    } else if (this.job && this.job.lob === 'SI') {
      job = new RailwayExportJob(this.job)
    } else {
      job = new SeaExportJob(this.job)
    }
    return job
  }
  /**
   * 显示内结费用
   */
  showInternalChargeHandler() {
    this.loadChargeDataFunc()
  }
}
